import React, { useContext } from 'react';
import {
    Box,
    Button,
    MenuItem,
    TextField,
    Grid,
} from '@mui/material';
import '../../assets/styles/FilterBar.scss';
import { WarehouseMasterContext } from '../../context';
import { status as statusOptions } from '../../utils/config';

export default function FilterBar() {
    const { filters, setFilters, initialFilters, onLoadApi } = useContext(WarehouseMasterContext);

    const handleChange = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
    };

    const handleSubmit = () => {
        onLoadApi();
    };

    const handleReset = () => {
        setFilters(initialFilters);
        onLoadApi(initialFilters);
    };

    return (
        <Box className="shipment-filter-bar">
            <Grid container spacing={2}>
                <Grid item size={{ xs: 12, md: 6 }}>
                    <div className="search-box">
                        <TextField
                            select
                            name="searchBy"
                            value={filters.searchBy}
                            onChange={(e) => handleChange('searchBy', e.target.value)}
                            size="small"
                            className="search-select"
                            SelectProps={{
                                displayEmpty: true,
                            }}
                        >
                            <MenuItem value="name">Warehouse Name</MenuItem>
                            <MenuItem value="contact_person">Contact Person</MenuItem>
                            <MenuItem value="contact_mobile">Contact Mobile</MenuItem>
                            <MenuItem value="city">City</MenuItem>
                            <MenuItem value="pincode">Pincode</MenuItem>
                            <MenuItem value="id">ID</MenuItem>
                        </TextField>

                        <TextField
                            size="small"
                            placeholder={`Enter ${filters.searchBy?.toLowerCase().replace(/_/g, ' ') || 'value'} here`}
                            value={filters.searchValue}
                            onChange={(e) => handleChange('searchValue', e.target.value)}
                            className="search-input"
                        />
                    </div>
                </Grid>

                <Grid item size={{ xs: 12, md: 6 }}>
                    <TextField
                        select
                        label="Status"
                        name="status"
                        value={filters.status}
                        onChange={(e) => handleChange('status', e.target.value)}
                        fullWidth
                        size="small"
                    >
                        <MenuItem value="">Status</MenuItem>
                        {Object.entries(statusOptions).map(([key, value]) => (
                            <MenuItem value={key} key={key}>
                                {value}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item size={{ xs: 12, md: 12 }}>
                    <Box className="filter-actions">
                        <Box>
                            <Button className="search-btn" variant="contained" size="medium" onClick={handleSubmit}>
                                Search
                            </Button>

                            <Button className="reset-btn ml-2" variant="outlined" size="medium" onClick={handleReset}>
                                Reset
                            </Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
